import CalendarBase from 'antd/es/calendar';

export default CalendarBase;
